import { atom } from 'recoil';

export const animateFriendState = atom({
  key: 'animateFriendState', 
  default: null
});